'use strict';

define('components/nav/navigation.zip',['./navigation', 'zipTools', 'storageUtil'], function (Navigation, zipTools, storageUtil) {
  var ZipNavPlugin = Navigation.Plugin.extend({
    bindEvents: function () {
      var nav = this.getNavigation();
      nav.$el.on('blur', 'input[name="zip"]', this.onZipInputBlur.bind(this));
      nav.$el.on('keyup', 'input[name="zip"]', this.onZipInputKeyUp.bind(this));
    },

    onZipInputBlur: function (e) {
      var $input = $(e.currentTarget);
      var maxLen = parseInt($input.attr('maxlength'));
      var len = $input.val().trim().length;

      if (len < maxLen) {
        if (storageUtil.isConfirmedZip() === true) {
          zipTools.updateZipFields(storageUtil.getZip());
        } else {
          $input.val('');
        }
      }
    },

    onZipInputKeyUp: function (e) {
      var $input = $(e.currentTarget);
      var maxLen = parseInt($input.attr('maxlength'));
      var len = $input.val().trim().length;

      if ($input.is(':focus') && len === maxLen) {
        zipTools.changeZip(storageUtil.getZip(), $input.val(), '/', void 0, false, false);
        $input.blur();
      }
    }
  });

  Navigation.registerPlugin(ZipNavPlugin);
});

